import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UsersService } from '@flashvpn-io/web-core';

export const authGuard: CanActivateFn = async (route, state) => {
  const usersService = inject(UsersService);
  const router = inject(Router);

  try {
    const isLoggedIn = await usersService.isLoggedIn();
    if (isLoggedIn) {
      return true;
    } else {
      router.navigate(['/users/signin']);
      return false;
    }
  } catch (error) {
    console.error('Authentication check failed', error);
    router.navigate(['/users/signin']);
    return false;
  }
};